
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ueber-uns",
      function () {
        return require("private-next-pages/ueber-uns.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ueber-uns"])
      });
    }
  